var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inherit"}},[(this.$route.name !== 'browse')?_c('router-link',{staticClass:"navbar-item",attrs:{"to":{ name: 'browse' }}},[_c('b-icon',{staticClass:"is-hidden-desktop menu-icon",attrs:{"icon":"table"}}),_vm._v("\n    "+_vm._s(_vm.$t('browse'))+"\n  ")],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-051a8d91","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewAppToolbar.vue
// module id = 5qOA
// module chunks = 1